// extracted by mini-css-extract-plugin
export var attachButton = "_db-8";
export var sendButton = "_db-2";
export var sendDisabled = "_db-4";
export var sendEnabled = "_db-3";
export var sendIcon = "_db-6";
export var sendIconDisabled = "_db-7";
export var sendStreaming = "_db-5";
export var textarea = "_db-1";
export var wrapper = "_db-0";